import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';
import { RoleId } from 'garaje/utils/custom-roles';

export default Factory.extend({
  name: () => faker.company.name(),
  isBeta: false,
  samlConnected: false,
  onboardingStatus: 'complete',
  planIntent: 'premium',
  active: true,

  withConfig: trait({
    afterCreate(company, server) {
      server.create('company-config', {
        id: company.id,
      });
    },
  }),

  withConfiguration: trait({
    afterCreate(company, server) {
      server.create('company-configuration', {
        company,
      });
    },
  }),

  withLocation: trait({
    afterCreate(company, server) {
      server.create('location', 'withConfig', { company });
    },
  }),

  withBillingCompany: trait({
    afterCreate(company, server) {
      server.create('billing-company', { company });
    },
  }),

  withGlobalAdmin: trait({
    afterCreate(company, server) {
      const companyRole = server.create('company-role', { company }, 'withUser', 'asGlobalAdmin');
      const user = companyRole.user;

      server.create('role-assignment', {
        userId: user.id,
        roleId: RoleId.GLOBAL_ADMIN,
        roleScopeId: company.id,
        roleScopeName: company.name,
        roleScopeType: 'company',
      });
    },
  }),

  asTrialExpired: trait({
    active: false,
  }),
});
